import { Base } from '../Base';
export  class ReportHeaderColumn extends Base
{

	
	


public columns:any = {
				
				ActualCost : {
					label : "Actual Cost",
					width : "60",
					type : "number"
				},
				
				ActualUnitPrice : {
					label : "Actual Unit Price",
					width : "60",
					type : "number"
				},
				UnitCost : {
					label : "Unit Cost",
					width : "60",
					type : "number"
				},
				AmountLeftOnTable : {
					label : "Amount Left On Table",
					width : "60",
					type : "number"
				},
				
				AmountSaved : {
					label : "Amount Saved",
					width : "60",
					type : "number"
				},
				
				EquipmentSerialNumber : {
					label : "Serial #/Internal ID",
					width : "100",
					type : "string"
				},
				equipmentserialnumber : {
					label : "Serial #/Internal ID",
					width : "100",
					type : "string"
				},
				
				EquipmentTypeCode : {
					label : "Equipment Type Code",
					width : "100",
					type : "string"
				},
				
				isAlternatePartFlag : {
					label : "Alternate Part?",
					width : "60",
					type : "string"
				},
				
				isAlternatePart: {
					label : "Alternate Part?",
					width : "60",
					type : "string"
				},
				
				isHighestCostOption : {
					label : "Highest Cost?",
					width : "60",
					type : "string"
				},
				
				isRGAQualified : {
					label : "RGA Qualified?",
					width : "60",
					type : "string"
				},					
				
				isRGAQualifiedFlag : {
					label : "RGA Qualified?",
					width : "60",
					type : "string"
				},
				
				isTotalCostZero : {
					label : "Total Cost Zero?",
					width : "60",
					type : "string"
				},
				
				MonthOfService : {
					label : "Month Of Service",
					width : "60",
					type : "number"
				},
				
				PartGroup : {
					label : "Part Group",
					width : "60",
					type : "number"
				},
				
				replacedDays : {
					label : "Replaced Days",
					width : "60",
					type : "number"
				},

				ReplacedDays : {
					label : "Replaced Days",
					width : "60",
					type : "number"
				},
				
				TicketPartSourceCode : {
					label : "Ticket Part Source Code",
					width : "100",
					type : "string"
				},
				
				TotalCost : {
					label : "Total Cost",
					width : "60",
					type : "number"
				},
				
				TotalHighestCost : {
					label : "Total Highest Cost",
					width : "60",
					type : "number"
				},
				
				TotalLowestCost : {
					label : "Total Lowest Cost",
					width : "60",
					type : "number"
				},
				
				UnitPrice : {
					label : "Unit Price",
					width : "60",
					type : "number"
				},
				
				WorkTypeCode : {
					label : "Work Type Code",
					width : "100",
					type : "string"
				},
				
				YearOfService : {
					label : "Year Of Service",
					width : "60",
					type : "number"
				},

				EquipmentTypeDescription : {
					label : "Equipment Type",
					width : "120",
					type : "string"
				},
				equipmenttypedescription : {
					label : "Equipment Type",
					width : "120",
					type : "string"
				},

				ManufacturerName : {
					label : "Manufacturer",
					width : "80",
					type : "string"
				},

				manufacturername : {
					label : "Manufacturer",
					width : "80",
					type : "string"
				},

				ModelNumber : {
					label : "Model",
					width : "120",
					type : "string"
				},
				modelnumber : {
					label : "Model",
					width : "120",
					type : "string"
				},

				modelNumber : {
					label : "Model",
					width : "120",
					type : "string"
				},

				dateoflastrepair : {
					label : "Date of Repair",
					width : "80",
					type : "date"
				},
				DateOfLastRepair : {
					label : "Date of Repair",
					width : "80",
					type : "date"
				},
				worktypedescription : {
					label : "Type of Work",
					width : "120",
					type : "string"
				},
				WorkTypeDescription : {
					label : "Type of Work",
					width : "120",
					type : "string"
				},

				workTypeId : {
					label : "Work Type ID",
					width : "50",
					type : "number"
				},
				WorkTypeID : {
					label : "Work Type ID",
					width : "50",
					type : "number"
				},


				Findings : {
					label : "Findings",
					width : "200",
					type : "string"
				},

				findings : {
					label : "Findings",
					width : "200",
					type : "string"
				},

				WorkPerformed : {
					label : "Work Performed",
					width : "200",
					type : "string"
				},

				workperformed : {
					label : "Work Performed",
					width : "200",
					type : "string"
				},

				CoveredBy : {
					label : "Work Performed",
					width : "200",
					type : "string"
				},

				createdby : {
					label : "Tech Name",
					width : "100",
					type : "string"
				},

				ClockHours : {
					label : "Clock Hours",
					width : "60",
					type : "number"
				},

				clockhours : {
					label : "Clock Hours",
					width : "60",
					type : "number"
				},

				DateWarrantyExpires : {
					label : "Date Warranty Expires",
					width : "120",
					type : "date"
				},

				isReplacingWarrantyPart : {
					label : "Replacing Warranty Part?",
					width : "60",
					type : "string"
				},

				PartCount : {
					label : "Part Count",
					width : "60",
					type : "number"
				},

				RGANumber : {
					label : "RGA Number",
					width : "60",
					type : "string"
				},
				
				ServiceRequested : {
					label : "Service Requested",
					width : "200",
					type : "string"
				},

				servicerequested : {
					label : "Service Requested",
					width : "200",
					type : "string"
				},
				
				TicketNumber : {
					label : "Ticket Number",
					width : "130",
					type : "string"
				},
				ticketNumber : {
					label : "Ticket Number",
					width : "130",
					type : "string"
				},
				
				DateTicketClosed  : {
					label : "Date Ticket Closed",
					width : "120",
					type : "Date"
				},
				
				ClosedBy  : {
					label : "Closed By",
					width : "120",
					type : "string"
				},

				closedby  : {
					label : "Closed By",
					width : "120",
					type : "string"
				},
				
				HoursWork  : {
					label : "Hours Worked",
					width : "50",
					type : "number"
				},
				
				HoursTravel   : {
					label : "Hours Travel",
					width : "50",
					type : "number"
				},
				
				TotalHours   : {
					label : "Clock Hours",
					width : "50",
					type : "number"
				},
				
				DateServiceCompleted   : {
					label : "Date Service Completed",
					width : "80",
					type : "date"
				},
				
				FacilityNumber   : {
					label : "Location Number",
					width : "50",
					type : "number"
				},

				facilityNumber   : {
					label : "Location Number",
					width : "50",
					type : "number"
				},

				FACILITYNUMBER   : {
					label : "LOCATION NUMBER",
					width : "50",
					type : "number"
				},
				
				EquipmentModel   : {
					label : "Equipment Model",
					width : "80",
					type : "string"
				},
				
				DateOfOriginalInstall   : {
					label : "Original Install Date",
					width : "80",
					type : "string"
				},
				
				TicketCreated   : {
					label : "Ticket Created",
					width : "80",
					type : "Date"
				},
				
				TicketClosed   : {
					label : "Ticket Closed",
					width : "80",
					type : "Date"
				},
				
				PartNumber   : {
					label : "Part Number",
					width : "80",
					type : "string"
				},
				
				PartDescription   : {
					label : "Part Description",
					width : "120",
					type : "string"
				},
				
				Quantity   : {
					label : "Quantity",
					width : "50",
					type : "number"
				},
				
				DivisionName    : {
					label : "Division Name",
					width : "140",
					type : "string"
				},
				divisionName    : {
					label : "Division Name",
					width : "140",
					type : "string"
				},
				
				RegionName    : {
					label : "Region Name",
					width : "140",
					type : "string"
				},
				regionName    : {
					label : "Region Name",
					width : "140",
					type : "string"
				},
				
				FacilityName    : {
					label : "Location Name",
					width : "140",
					type : "string"
				},
				
				facilityName    : {
					label : "Location Name",
					width : "140",
					type : "string"
				},
				FACILITYNAME    : {
					label : "LOCATION NAME",
					width : "140",
					type : "string"
				},
				teammate_ceridian_num    : {
					label : "Employee Number",
					width : "60",
					type : "number"
				},
				Teammate_Ceridian_Num    : {
					label : "Employee Number",
					width : "60",
					type : "number"
				},
				
				payrollCode     : {
					label : "Payroll Code",
					width : "50",
					type : "number"
				},

				PayrollCode     : {
					label : "Payroll Code",
					width : "50",
					type : "number"
				},
				
				SQACode     : {
					label : "SQA Code",
					width : "80",
					type : "string"
				},
				sqacode     : {
					label : "SQA Code",
					width : "80",
					type : "string"
				},
				
				SQASubCode      : {
					label : "SQA Sub Code",
					width : "50",
					type : "string"
				},
				
				TicketClosedDate       : {
					label : "Ticket Closed",
					width : "90",
					type : "date"
				},
				
				RegionNumber       : {
					label : "Region Number",
					width : "60",
					type : "string"
				},
				
				DateServicePerformed        : {
					label : "Date Service Performed",
					width : "90",
					type : "date"
				},

				dateserviceperformed        : {
					label : "Date Service Performed",
					width : "90",
					type : "date"
				},

				isScheduledFlag         : {
					label : "Is Scheduled",
					width : "60",
					type : "number"
				},

				IsScheduledFlag         : {
					label : "Is Scheduled",
					width : "60",
					type : "number"
				},
				
				isScheduled         : {
					label : "Is Scheduled",
					width : "60",
					type : "number"
				},

				EquipmentTypeId : {
					label : "Equipment Type ID",
					width : "60",
					type : "number"
				},
				EquipmentTypeID : {
					label : "Equipment Type ID",
					width : "60",
					type : "number"
				},

				rank : {
					label : "Rank",
					width : "50",
					type : "number"
				},

				seq : {
					label : "Seq",
					width : "60",
					type : "number"
				},

				type : {
					label : "Type",
					width : "120",
					type : "string"
				},

				value : {
					label : "Value",
					width : "60",
					type : "number"
				},

				Value : {
					label : "Value",
					width : "60",
					type : "number"
				},

				GroupName : {
					label : "Group",
					width : "100",
					type : "string"
				},
				groupName : {
					label : "Group",
					width : "100",
					type : "string"
				},

				Model : {
					label : "Model",
					width : "100",
					type : "string"
				},

				SQADescription : {
					label : "SQA Description",
					width : "100",
					type : "string"
				},

				TicketCount : {
					label : "Ticket Count",
					width : "60",
					type : "number"
				},

				ticketCount
				: {
					label : "Ticket Count",
					width : "60",
					type : "number"
				},

				division : {
					label : "Division",
					width : "100",
					type : "string"
				},
				
				Division : {
					label : "Division",
					width : "100",
					type : "string"
				},

				Facility : {
					label : "Location",
					width : "100",
					type : "string"
				},
				facility: {
					label : "Location",
					width : "100",
					type : "string"
				},				
				Region : {
					label : "Region",
					width : "100",
					type : "string"
				},
				
				EquipmentStatusCode : {
					label : "Equip Status Code",
					width : "100",
					type : "string"
				},
				
				EquipmentSubTypeDescription : {
					label : "Equip Sub Type",
					width : "100",
					type : "string"
				},
				
				EquipmentID : {
					label : "Equip ID",
					width : "60",
					type : "string"
				},

				equipmentid : {
					label : "Equip ID",
					width : "60",
					type : "string"
				},
				equipmentId : {
					label : "Equip ID",
					width : "60",
					type : "string"
				},
				
				LastPMDate : {
					label : "Last PM Date",
					width : "80",
					type : "date"
				},
				
				pmScheduleId : {
					label : "PM Sched ID",
					width : "60",
					type : "string"
				},
				PMScheduleID : {
					label : "PM Sched ID",
					width : "60",
					type : "string"
				},
				
				PMScheduleDescription : {
					label : "PM Sched Description",
					width : "100",
					type : "string"
				},
				
				LastPMTicket : {
					label : "Last PM Ticket",
					width : "100",
					type : "string"
				},
				
				LastHoursOnMachine : {
					label : "Last Hours On Machine",
					width : "100",
					type : "string"
				},
				
				isChecklistCompletedFlag : {
					label : "Check List Completed?",
					width : "60",
					type : "string"
				},
				
				NextPMDateByCal : {
					label : "Next PM Date",
					width : "100",
					type : "date"
				},
				
				PMSQACode : {
					label : "PM SQA Code",
					width : "100",
					type : "string"
				},

				pmsqacode : {
					label : "PM SQA Code",
					width : "100",
					type : "string"
				},
				
				ChecklistCompleted  : {
					label : "Checklist Completed",
					width : "100",
					type : "string"
				},
				
				Vendor  : {
					label : "Vendor",
					width : "100",
					type : "string"
				},
												
				DateClosed : {
					label : "Closed",
					width : "80",
					type : "date"
				},
				
				MonthsInstalled  : {
					label : "Months Installed",
					width : "100",
					type : "string"
				},
				
				pmTickets  : {
					label : "PM Tickets",
					width : "80",
					type : "number"
				},
				
				nonPmTickets  : {
					label : "Non PM Tickets",
					width : "80",
					type : "number"
				},
				
				scheduledTickets : {
					label : "Scheduled Tickets",
					width : "80",
					type : "number"
				},
				
				periodBegin : {
					label : "Period Begin",
					width : "80",
					type : "date"
				},

				PeriodBegin : {
					label : "Period Begin",
					width : "80",
					type : "date"
				},
				
				periodEnd : {
					label : "Period End",
					width : "80",
					type : "date"
				},

				PeriodEnd : {
					label : "Period End",
					width : "80",
					type : "date"
				},
				
				dateOfLastPm : {
					label : "Last PM",
					width : "80",
					type : "date"
				},
				DateOfLastPM : {
					label : "Last PM",
					width : "80",
					type : "date"
				},
				PartNumber1 : {
					label : "Part Number 1",
					width : "100",
					type : "number"
				},
				
				PartDescription1 : {
					label : "Part Description 1",
					width : "100",
					type : "string"
				},
				PartQuantity1 : {
					label : "Part Qty 1",
					width : "100",
					type : "number"
				},
				partQuantity1 : {
					label : "Part Qty 1",
					width : "100",
					type : "number"
				},
				
				PartNumber2 : {
					label : "Part Number 2",
					width : "100",
					type : "number"
				},
				
				PartDescription2 : {
					label : "Part Description 2",
					width : "100",
					type : "string"
				},
				
				partQuantity2 : {
					label : "Part Qty 2",
					width : "100",
					type : "number"
				},
				PartQuantity2 : {
					label : "Part Qty 2",
					width : "100",
					type : "number"
				},

				PartNumber3 : {
					label : "Part Number 3",
					width : "100",
					type : "number"
				},
				
				PartDescription3 : {
					label : "Part Description 3",
					width : "100",
					type : "string"
				},
				
				partQuantity3 : {
					label : "Part Qty 3",
					width : "100",
					type : "number"
				},
				
				PartQuantity3 : {
					label : "Part Qty 3",
					width : "100",
					type : "number"
				},

				PartNumber4 : {
					label : "Part Number 4",
					width : "100",
					type : "number"
				},
				
				PartDescription4 : {
					label : "Part Description 4",
					width : "100",
					type : "string"
				},
				
				partQuantity4 : {
					label : "Part Qty 4",
					width : "100",
					type : "number"
				},
				PartQuantity4 : {
					label : "Part Qty 4",
					width : "100",
					type : "number"
				},

				PartNumber5 : {
					label : "Part Number 5",
					width : "100",
					type : "number"
				},
				
				PartDescription5 : {
					label : "Part Description 5",
					width : "100",
					type : "string"
				},
				
				partQuantity5 : {
					label : "Part Qty 5",
					width : "100",
					type : "number"
				},
				PartQuantity5 : {
					label : "Part Qty 5",
					width : "100",
					type : "number"
				},
				EquipmentCount : {
					label : "Equip. Count",
					width : "100",
					type : "number"
				},
				
				WarrantyCount : {
					label : "Warranty Count",
					width : "100",
					type : "number"
				},

				EquipmentVintage  : {
					label : "Equip Vintage",
					width : "100",
					type : "number"
				},
				
				AvgEquipmentVintage  : {
					label : "Avg. Equip Vintage",
					width : "100",
					type : "number"
				},

				AvgEquipmentVINTage  : {
					label : "Avg. Equip Vintage",
					width : "100",
					type : "number"
				},				
				
				TotalTicketCount   : {
					label : "Total Ticket Count",
					width : "100",
					type : "number"
				},
				
				TotalPMTicket   : {
					label : "Total PM Tickets",
					width : "100",
					type : "number"
				},
				
				PMpct   : {
					label : "PM %",
					width : "50",
					type : "number"
				},
				
				TotalNonPMTicket : {
					label : "Total Non-PM Ticket",
					width : "100",
					type : "number"
				},
				
				NonPMpct  : {
					label : "Non-PM %",
					width : "50",
					type : "number"
				},
				
				TotalScheduledTicket   : {
					label : "Total Scheduled Ticket",
					width : "100",
					type : "number"
				},
				
				Unscheduledpct    : {
					label : "Unscheduled %",
					width : "100",
					type : "number"
				},
				
				TotalPartCount : {
					label : "Total Part Count",
					width : "100",
					type : "number"
				},
				
				TotalPartCost : {
					label : "Total Part Cost",
					width : "100",
					type : "number"
				},
				
				AvgTouchPerMachine : {
					label : "Avg. Touch Per Machine",
					width : "100",
					type : "number"
				},
				
				AvgHoursPerMachine : {
					label : "Avg. Hours Per Machine",
					width : "100",
					type : "number"
				},
				
				AvgPartCountPerMachine  : {
					label : "Avg. Part Count Per Machine",
					width : "100",
					type : "number"
				},
				
				AvgPartCostPerMachine  : {
					label : "Avg. Part Cost Per Machine",
					width : "100",
					type : "number"
				},
				
				AvgHoursPerTicket  : {
					label : "Avg. Hours Per Ticket",
					width : "100",
					type : "number"
				},
				
								
				AvgPartCountPerTicket  : {
					label : "Avg. Part Count Per Ticket",
					width : "100",
					type : "number"
				},
				
				AvgPartCostPerTicket   : {
					label : "Avg. Part Cost Per Ticket",
					width : "100",
					type : "number"
				},
				
				DateOfPriorPM   : {
					label : "Date of Prior PM",
					width : "100",
					type : "date"
				},
				
				PriorPMDescription   : {
					label : "Prior PM Description",
					width : "100",
					type : "string"
				},
				
				DateOfPM  : {
					label : "Date of PM",
					width : "100",
					type : "date"
				},
				
				PMDescription  : {
					label : "PM Description",
					width : "100",
					type : "string"
				},
				
				serviceRequestStatus  : {
					label : "Service Request Status",
					width : "100",
					type : "string"
				},
				
				DatePMCompleted  : {
					label : "Date PM Completed",
					width : "100",
					type : "date"
				},
				
				DaysOverdue  : {
					label : "Days Overdue",
					width : "100",
					type : "number"
				},
				
				equipmentSubTypeID : {
					label : "Equipment Sub Type ID",
					width : "100",
					type : "number"
				},
				
				dateServiceBegan  : {
					label : "Date Service Began",
					width : "80",
					type : "date"
				},
				
				SQASubDescription : {
					label : "SQA Sub Descrip.",
					width : "100",
					type : "string"
				},
				
				groupNumber : {
					label : "Group ##",
					width : "70",
					type : "number"
				},
				
				divisionNumber : {
					label : "Division ##",
					width : "70",
					type : "string"
				},
				
				dateTicketCreated   : {
					label : "Date Ticket Created",
					width : "80",
					type : "date"
				},
				
				ScheduledTouchCount : {
					label : "Scheduled Ticket Count",
					width : "80",
					type : "number"
				},
				
				UnScheduledTouchCount : {
					label : "Unscheduled Touch Count",
					width : "80",
					type : "number"
				},
							
				PMPartCount : {
					label : "PM Part Count",
					width : "80",
					type : "number"
				},
				
				RepairPartCount : {
					label : "Repair Part Count",
					width : "80",
					type : "number"
				},
				
				PMPartCost : {
					label : "PM Part Cost",
					width : "80",
					type : "number"
				},
				
				RepairPartCost : {
					label : "Repair Part Cost",
					width : "80",
					type : "number"
				},
				
				PMHours : {
					label : "PM Hours",
					width : "80",
					type : "number"
				},
				
				RepairHours : {
					label : "Repair Hours",
					width : "80",
					type : "number"
				},
				
				PriorPMTicket : {
					label : "Prior PM Ticket",
					width : "80",
					type : "string"
				},
				
				isQualificationChecklistFlag : {
					label : "Qual. Checklist Flag",
					width : "80",
					type : "number"
				},
				
				DateOfNextPM : {
					label : "Date Next PM",
					width : "100",
					type : "date"
				},
				
				DateOfNextPM2 : {
					label : "Date Next PM 2",
					width : "100",
					type : "date"
				},
				
				DateOfNextPM3 : {
					label : "Date Next PM 3",
					width : "100",
					type : "date"
				},
				
				DateOfNextPM4 : {
					label : "Date Next PM 4",
					width : "100",
					type : "date"
				},
				
				TypeOfNextPM : {
					label : "Type Next PM",
					width : "80",
					type : "string"
				},
				
				TypeOfNextPM2 : {
					label : "Type Next PM 2",
					width : "80",
					type : "string"
				},
				
				TypeOfNextPM3 : {
					label : "Type Next PM 3",
					width : "80",
					type : "string"
				},
				
				TypeOfNextPM4 : {
					label : "Type Next PM 4",
					width : "80",
					type : "string"
				},
				
				DatePMDue : {
					label : "Date PM due",
					width : "100",
					type : "date"
				},
				
				PMStatus : {
					label : "PM Status",
					width : "80",
					type : "string"
				},

				BatchDescription : {
					label : "Type of Batch",
					width : "120",
					type : "string"
				},

				BatchID : {
					label : "Batch ID",
					width : "50",
					type : "number"
				},
				
				RYear : {
					label : "RYear",
					width : "60",
					type : "string"
				},

				RMonth : {
					label : "RMonth",
					width : "60",
					type : "string"
				},

				ReportDivisionName : {
					label : "ReportDivisionName",
					width : "80",
					type : "string"
				},

				ReportRegionName : {
					label : "ReportRegionName",
					width : "80",
					type : "string"
				},

				FacilityNo : {
					label : "LocationNo",
					width : "60",
					type : "string"
				},

				QuestionID : {
					label : "QuestionID",
					width : "80",
					type : "string"
				},

				Question_Text : {
					label : "Question_Text",
					width : "80",
					type : "string"
				},

				Answer : {
					label : "Answer",
					width : "80",
					type : "string"
				},

				Comments : {
					label : "Comments",
					width : "80",
					type : "string"
				},

				QType_ID : {
					label : "QType_ID",
					width : "60",
					type : "string"
				},

				QType_Descr : {
					label : "QType_Descr",
					width : "80",
					type : "string"
				},

				SClassID : {
					label : "SClassID",
					width : "60",
					type : "string"
				},

				SClassDescription : {
					label : "SClassDescription",
					width : "100",
					type : "string"
				},

				EquipmentDescription : {
					label : "Equipment Description",
					width : "80",
					type : "string"
				},
				
				PC_ResponseMasterNumber : {
					label : "PC Response Master Number",
					width : "100",
					type : "string"
				},

				PACDescription : {
					label : "PAC Description",
					width : "100",
					type : "string"
				},

				QuestionText : {
					label : "Question Text",
					width : "80",
					type : "string"
				},

				Hepatitis_B_Antigen : {
					label : "Hepatitis B Antigen",
					width : "80",
					type : "string"
				},
	
				Flowsheet_ID : {
					label : "Flowsheet ID",
					width : "80",
					type : "string"
				},

				DelayReason : {
					label : "DelayReason",
					width : "80",
					type : "string"
				},

				IntendedDate : {
					label : "Intended Date",
					width : "100",
					type : "datetime"
				},
				
				Date_Of_Prior_Filter_Replacement : {
					label : "Date Of Prior Filter Replacement",
					width : "120",
					type : "datetime"
				},

				Prior_Filter_Replacement_Ticket : {
					label : "Prior Filter Replacement Ticket",
					width : "120",
					type : "string"
				},

				Days_Prior_Filter_Replacement_Overdue : {
					label : "Days Prior Filter Replacement Overdue",
					width : "120",
					type : "string"
				},

				Date_Of_Next_Filter_Replacement : {
					label : "Date Of Next Filter Replacement",
					width : "120",
					type : "datetime"
				},

				EquipmentSubTypeCode : {
					label : "Equipment Sub Type Code",
					width : "100",
					type : "string"
				},

				DateCreated : {
					label : "Date Created",
					width : "100",
					type : "datetime"
				},

				LastClockHours : {
					label : "Current Hours",
					width : "100",
					type : "string"
				},

				
				DateEquipmentServiced : {
					label : "Date Equipment Serviced",
					width : "100",
					type : "datetime"
				},

				TestEqpSerialNumber : {
					label : "Test Equipment Serial Number",
					width : "100",
					type : "string"
				},

				
				CalibrationDateOnService : {
					label : "Calibration Date On Service",
					width : "100",
					type : "datetime"
				},
				
				CalibrationDateonService : {
					label : "Calibration Date On Service",
					width : "100",
					type : "datetime"
				},

				TestEqpDetails : {
					label : "Test Equipment Details",
					width : "100",
					type : "string"
				},

				Hepatitis_B_Antibody : {
					label : "Hepatitis B Antibody",
					width : "80",
					type : "string"
				},

				Process : {
					label : "Process",
					width : "80",
					type : "string"
				},

				CompletedBy : {
					label : "CompletedBy",
					width : "100",
					type : "string"
				},
				LastName : {
					label : "Closed By",
					width : "100",
					type : "string"
				},
				BatchName : {
					label : "Batch Name",
					width : "100",
					type : "string"
				},
				TotalLabor : {
					label : "Clock Hours",
					width : "100",
					type : "string"
				},			
				pmEvents : {
					label : "PM Events",
					width : "100",
					type : "string"
				},
				disinfectionCultureEvents : {
					label : "Disinfection Culture Events",
					width : "100",
					type : "string"
				},
				sDateClosed : {
					label : "Closed",
					width : "80",
					type : "string"
				},
				sDateServicePerformed        : {
					label : "Date Service Performed",
					width : "90",
					type : "string"
				},					
				sDateOfOriginalInstall   : {
					label : "Original Install Date",
					width : "80",
					type : "string"
				},
				TXDay : {
					label : "Treatment Date",
					width : "100",
					type : "datetime"
				},
				Previousdate : {
					label : "Previous Date",
					width : "80",
					type : "datetime"
				},
				Daysbetween : {
					label : "Days Between",
					width : "80",
					type : "string"
				},
				previousdate : {
					label : "Previous Date",
					width : "80",
					type : "datetime"
				},
				daysbetween : {
					label : "Days Between",
					width : "80",
					type : "string"
				},	
				PC_ResponseMasterID : {
					label : "PC_ResponseMasterID",
					width : "160",
					type : "string"
				},	
				PACID : {
					label : "PACID",
					width : "80",
					type : "string"
				},	
				HepBAntigen : {
					label : "HepBAntigen",
					width : "80",
					type : "string"
				},	
				HepBAntibody : {
					label : "HepBAntibody",
					width : "80",
					type : "string"
				},	
				FlowsheetID : {
					label : "FlowsheetID",
					width : "80",
					type : "string"
				},	
				FullNameFirstLast : {
					label : "FullNameFirstLast",
					width : "160",
					type : "string"
				},	
				nextPACDescription : {
					label : "Next PAC Description",
					width : "80",
					type : "string"
				},	
				nextpacdate : {
					label : "Next PAC Date",
					width : "100",
					type : "datetime"
				},	
				minutesbetween : {
					label : "Minutes Between",
					width : "80",
					type : "string"
				},	
				nextFlowsheetID : {
					label : "Next FlowsheetID",
					width : "80",
					type : "string"
				},
				Mobile_equipmentStatusCode : {
					label : "Equip Status Code",
					width : "500",
					type : "string"
				},
				Mobile_EquipmentSerialNum : {
					label : "Equip Serial Number",
					width : "500",
					type : "string"
				},
				IP : {
					label : "IP Address",
					width : "100",
					type : "string"
				}	,
				NickName : {
					label : "NickName",
					width : "200",
					type : "string"
				},
				SoftwareVersion : {
					label : "Software Version",
					width : "100",
					type : "string"
				},
				Module1 : {
					label : "Module 1",
					width : "100",
					type : "string"
				},
				Module2 : {
					label : "Module 2",
					width : "100",
					type : "string"
				},
				ModalityID : {
					label : "Modality",
					width : "100",
					type : "string"
				},
				State : {
					label : "State",
					width : "50",
					type : "string"
				},
				DrawDate:{
					label : "DRAW DATE",
					width : "100",
					type : "string"
				},
				EquipmentDisplayName:{
					label : "MODEL # | NICKNAME | SERIAL # | EQUIPMENT ID",
					width : "290",
					type : "string"
				},
				LabComments:{
					label : "LAB COMMENTS",
					width : "390",
					type : "string"
				},
				LabRequisitionNumber:{
					label : "REQUISITION ID",
					width : "120",
					type : "string"
				},
				LabResult:{
					label : "RESULT | UNIT",
					width : "100",
					type : "string"
				},
				Status:{
					label : "STATUS",
					width : "100",
					type : "string"
				},
				TestDisplayName:{
					label : "TEST ID | NAME",
					width : "200",
					type : "string"
				}				
			};

		}